import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import About from '../views/About.vue'
import NotFound from '../views/NotFound.vue'
import Cooperation from '../views/Cooperation.vue'
import Dynamic from '../views/Dynamic.vue'
import Contact from '../views/Contact.vue'
import Product from '../views/Product.vue'
import NewsDetail from '../views/NewsDetail.vue'
import Chat from '../views/Chat.vue'
Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home
  },
  {
    path: '/About',
    name: 'About',
    component: () => import('../views/About.vue')
  },
  {
    path: '/Cooperation',
    name: 'Cooperation',
    component: () => import('../views/Cooperation.vue')
  },
  {
    path: '/Dynamic',
    name: 'Dynamic',
    component: () => import('../views/Dynamic.vue')
  },
  {
    path: '/Contact',
    name: 'Contact',
    component: () => import('../views/Contact.vue')
  },
  {
    path: '/Product',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/news/detail',
    name: 'NewsDetail',
    component: NewsDetail
  },
  {
    path: '/product',
    name: 'Product',
    component: () => import('../views/Product.vue')
  },
  {
    path: '/chat',
    name: 'Chat',
    component: () => import('../views/Chat.vue')
  },
  {
    path: '/:pathMatch(.*)*',
    name: 'NotFound',
    component: () => import('../views/NotFound.vue')
  }
]

const router = new VueRouter({
  mode: 'hash',
  base: process.env.BASE_URL,
  routes
})

export default router 